export default __webpack_public_path__ + "static/media/logo_only_white.c2a018c6.svg";